function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

/* eslint function-paren-newline: 0 */
const _ = require('lodash');

function _call(body, then, direct) {
  if (direct) {
    return then ? then(body()) : body();
  }

  try {
    var result = Promise.resolve(body());
    return then ? result.then(then) : result;
  } catch (e) {
    return Promise.reject(e);
  }
}

const Region = require('../entities/region');

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

const PagedList = require('../entities/paged-list');

const AccessContext = require('./contexts/access-context');

const symmetricDifference = require('../utils/symmetricDifference');
/*:: type Flags = {
  discoverable?: boolean;
  redeemable?: boolean
};*/


class OfferRegionsRepo {
  constructor(client
  /*: ApiClient*/
  , parentContext
  /*: AccessContext*/
  , offerId
  /*: string*/
  ) {
    this.client = client;
    this.context = parentContext;
    this.offerId = offerId;
  }

  getPath({
    /*: Flags*/

    discoverable,
    redeemable
  } = {}, regionId
  /*: string*/
  ) {
    if (!discoverable && !redeemable) throw new Error('Missing required arguments: either discoverable or redeemable');
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const offerId = this.offerId;
    const regionTypeToken = discoverable ? 'discoverableRegions' : 'redeemableRegions';
    const regionLinkToken = regionId ? `/${regionId}/link` : '';
    return `/properties/${propertyId}/businesses/${businessId}/offers/${offerId}/${regionTypeToken}${regionLinkToken}`;
  }

  list(flags
  /*: Flags*/
  )
  /*: Promise<PagedList<Region>>*/
  {
    const _this = this;

    return _call(function () {
      // Get regions from search index
      // TODO: Untangle this and remove the ability to define the "type" of region (id: `discoverable`)
      if (!flags.discoverable) {
        throw new Error('Missing required argument: discoverable');
      }

      const {
        propertyId,
        businessId
      } = _this.context.serialize();

      const offerId = _this.offerId;
      const path = `/properties/${propertyId}/businesses/${businessId}/offers/search`;
      const params = {
        offerId
      };
      const regionKey = flags.discoverable ? 'discoverableRegions' : 'redeemableRegions';
      const regionFields = [`${regionKey}(id)`];
      const req = new _this.client.Request(path, params, regionFields);
      return _await(_this.client.get(req), function (offers) {
        const regionIds = _.get(offers, `items[0].${regionKey}`, []).map(({
          id
        }) => id); // TODO: Get more region data added to offer search index so we don't need to make extra requests


        return _this.client.regions.multiDetails(regionIds);
      });
    });
  }

  link(regionId
  /*: string*/
  , flags
  /*: Flags*/
  )
  /*: Promise<any>*/
  {
    const path = this.getPath(flags, regionId);
    const req = new this.client.Request(path, {}, []);
    return this.client.put(req);
  }

  unlink(regionId
  /*: string*/
  , flags
  /*: Flags*/
  )
  /*: Promise<any>*/
  {
    const path = this.getPath(flags, regionId);
    const req = new this.client.Request(path, {}, []);
    return this.client.delete(req);
  }

  reconcile(regions
  /*: Array<string>*/
  , updatedRegions
  /*: Array<string>*/
  , flags
  /*: Flags*/
  ) {
    const {
      left,
      right
    } = symmetricDifference(regions, updatedRegions);
    const adding = Promise.all(right.map(id => this.link(id, flags)));
    const removing = Promise.all(left.map(id => this.unlink(id, flags)));
    return Promise.all([adding, removing]);
  }

  unlinkAll()
  /*: Promise<boolean>*/
  {
    const _this2 = this;

    return _call(function () {
      return _await(Promise.all(['discoverable'].map(_async(function (flag) {
        const flags = {
          [flag]: true
        };
        return _await(_this2.list(flags).then(_this2.client.pagination.loadRest), function (allRegions) {
          const regionIds = allRegions.items.map(r => r.id);
          return _this2.reconcile(regionIds, [], flags);
        });
      }))), function () {
        return _await(Promise.all([_this2.list({
          discoverable: true
        })]), function () {
          return true;
        });
      });
    });
  }

}

module.exports = OfferRegionsRepo;